module.exports = __webpack_public_path__ + "img/arrow-left-simple.058fdbe6.svg";